import type { Dayjs } from "dayjs";
import dayjs from "dayjs";

import { apiFormat, formatDate, fullMonthAndYear } from "@similarweb/pro-logic-components";

import { swSettings } from "app/common/services/swSettings";
import { translate } from "app/filters/i18nFilter";
import { EPeriodSupport, getSupportPeriod } from "app/UtilitiesAndConstants/UtilityFunctions/periodSupport";

import type { IMarketSizeText } from "./consts";

export const getUserSupportedPeriod = () => {
    const duration = swSettings.components?.IndustryAnalysisOverview?.resources?.Duration as number;
    return getSupportPeriod(duration);
};

export const getFromTo = () => {
    const userSupportedPeriod = getUserSupportedPeriod();

    const enddate = swSettings.components?.IndustryAnalysisOverview?.resources?.SnapshotInterval?.enddate as string;
    const to: Dayjs = dayjs(enddate);
    let from: Dayjs;

    switch (userSupportedPeriod) {
        case EPeriodSupport.Yearly:
            from = dayjs.utc(to).subtract(13, "month");
            break;
        case EPeriodSupport.Quarterly:
            from = dayjs.utc(to).subtract(4, "month");
            break;
        default:
            from = dayjs.utc(to).subtract(2, "month");
            break;
    }

    return {
        from: from.format(apiFormat),
        to: to.format(apiFormat),
    };
};

// Returns market overview text with internally formatted date parameters
export const getMarketOverviewText = (): IMarketSizeText => {
    const fromTo = getFromTo();
    const formattedFrom = formatDate(fromTo.from, null, fullMonthAndYear);
    const formattedTo = formatDate(null, fromTo.to, fullMonthAndYear);

    return {
        title: translate("market.overview.marketsize.widget.title"),
        uniqueVisitors: translate("market.overview.marketsize.widget.unique.visitors", {
            from: formattedFrom,
            to: formattedTo,
        }),
        change: {
            label: {
                quarterly: translate("market.overview.marketsize.widget.change.quaterly"),
                monthly: translate("market.overview.marketsize.widget.change.monthly"),
                yearly: translate("market.overview.marketsize.widget.change.yearly"),
            },
            tooltip: {
                quarterly: translate("market.overview.marketsize.widget.change.quaterly.tooltip"),
                monthly: translate("market.overview.marketsize.widget.change.monthly.tooltip"),
                yearly: translate("market.overview.marketsize.widget.change.yearly.tooltip", {
                    from: formattedFrom,
                    to: formattedTo,
                }),
            },
        },
        score: {
            label: translate("market.overview.marketsize.widget.score.title"),
            tooltip: translate("market.overview.marketsize.widget.score.tooltip"),
        },
    };
};
